// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { RequestEmissaoExigencia, EmissaoExigencia, Types } from './types';

export function emissaoExigenciasRequest(
	payload: RequestEmissaoExigencia,
): ReducerActionRotaSP {
	return {
		type: Types.EMISSAO_EXIGENCIAS_REQUEST,
		payload,
	};
}

export function emissaoExigenciasSuccess(
	payload: EmissaoExigencia,
): ReducerActionRotaSP {
	return {
		type: Types.EMISSAO_EXIGENCIAS_SUCCESS,
		payload,
	};
}

export function emissaoExigenciasFailure(): ReducerActionRotaSP {
	return {
		type: Types.EMISSAO_EXIGENCIAS_FAILURE,
		payload: null,
	};
}

export function emissaoExigenciasClear(): ReducerActionRotaSP {
	return {
		type: Types.EMISSAO_EXIGENCIAS_CLEAR,
		payload: null,
	};
}
